import { createFileRoute, redirect } from '@tanstack/react-router';
import { chatKeys } from '@/features/chat/hooks/queryKeys';

export const Route = createFileRoute('/_app/chat/')({
  beforeLoad: ({ context }) => {
    const chatId = crypto.randomUUID();
    // Pre-seed empty history so the destination route does not fetch
    // /api/chats/<unknown-id> and bounce on a 422.
    context.queryClient.setQueryData(chatKeys.history(chatId), []);
    throw redirect({ to: '/chat/$chatId', params: { chatId }, replace: true });
  },
});
